
import { mapActions, mapState, mapGetters } from "vuex";
import dialogCloseBtn from "../common/dialog-close-btn.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
import EmergencyLoader from "../common/emergency-loader.vue";
import OrderItemsList from "../reciever/order-items-list.vue";

export default {
  components: {
    dialogCloseBtn,
    ResponsiveDialog,
    EmergencyLoader,
    OrderItemsList
  },
  data() {
    return {
      panel: 0,
      onHoldDetailsLoading: false,
      onHoldDetails: [],
      countdownTimer: 0,
      timer: null,
      combos: [],
      onHoldItems: []
    };
  },
  props: {
    dialog: false
  },
  watch: {
    panel(val) {
      if (
        !isNaN(val) &&
        val !== null &&
        val >= 0 &&
        val < this.onHoldOrders.length
      ) {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.getOnHoldOrderDetailsOfSelectedPanel(val);
      }
    }
  },
  computed: {
    ...mapState("restaurant", ["printers"]),
    ...mapState("reciever", ["onHoldOrders"])
  },
  mounted() {
    this.getOnHoldOrderDetailsOfSelectedPanel(this.panel);
    setTimeout(() => {
      this.combos = this.getCombos();

      // combine list of combos with normal items
      this.onHoldItems = [...this.getOnHoldItems(), ...this.combos];
    }, 1000);
  },
  methods: {
    ...mapActions("reciever", ["getOrderDetailsObj", "getOrders"]),
    getOnHoldOrderDetailsOfSelectedPanel(index) {
      if (
        Number.isInteger(index) &&
        this.onHoldOrders &&
        this.onHoldOrders.length > 0
      ) {
        this.onHoldDetailsLoading = true;
        this.getOrderDetailsObj({
          orderId: this.onHoldOrders[index].id
        })
          .then((response) => {
            if (response) {
              this.onHoldDetails = response;
              this.setCountDownTimer(response.cancel_at);
            } else {
              this.$nuxt.$emit("show-error-toast", response);
            }
          })
          .catch((errr) => {
            this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            this.onHoldDetailsLoading = false;
          });
      }
    },
    setCountDownTimer(cancelTimestamp) {
      this.countdownTimer =
        this.getDateTimeDifferenceInSeconds(cancelTimestamp) * -1;

      if (this.countdownTimer > 0) {
        this.timer = setInterval(() => {
          this.countdownTimer--;
          if (this.countdownTimer === 0) {
            this.handleFetchOrders();
          }
        }, 1000);
      } else {
        this.countdownTimer = 0;
      }
    },
    async handleFetchOrders() {
      await this.sleep(1000);
      this.getOrders();
    },
    getCombos() {
      let combos = [];
      this.onHoldDetails?.items?.forEach((item) => {
        const duplicate = combos.find((combo) => combo.id === item.combo?.id);
        if (item.combo && !duplicate) {
          item.combo["items"] = [];
          item.combo["item_name"] = item.combo.name;
          item.combo["quantity"] = item.combo_quantity;
          combos.push(item.combo);
        }
      });
      return combos;
    },
    /**
     * Populate combos list with corresponding items and other items to different list
     */
    getOnHoldItems() {
      let onHoldItems = [];
      this.onHoldDetails?.items?.forEach((item) => {
        if (item.combo) {
          const matchingCombo = this.combos.find(
            (combo) => combo.id === item.combo.id
          );

          // mark the whole combo as out of stock if one of the items is out of stock
          matchingCombo.items.push(item);
          const isOutOfStock = matchingCombo.items.find(
            (item) => !!item.out_of_stock
          );
          matchingCombo["out_of_stock"] = isOutOfStock;
        } else {
          onHoldItems.push(item);
        }
      });
      return onHoldItems;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
